import { createTheme } from '@mui/material/styles'
import { TYPOGRAPHY } from './constants/customTheme'

export const theme = createTheme({
    typography: TYPOGRAPHY,
})
